/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { jwtDecode } from '@airasia-rn/ui/utils';

export function hasJwtExpired(
  token: string,
  offsetSeconds: number = 0,
): boolean {
  try {
    const decoded: { exp: number } = jwtDecode(token);
    const now = Date.now() / 1000;
    return decoded.exp < now + offsetSeconds;
  } catch {
    return true;
  }
}

export function getUserId(token?: string): string {
  if (!token) return '';
  try {
    const decoded: { userId: string } = jwtDecode(token);
    return decoded.userId;
  } catch {
    // The token itself is a credential — never log it.
    console.error('Error in getUserId: token could not be decoded');
    return '';
  }
}
